var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.135 0H3.365C1.508 0 0 1.425 0 3.182v21.636C0 26.575 1.508 28 3.365 28h10.77c1.857 0 3.365-1.425 3.365-3.182V3.182C17.5 1.425 15.992 0 14.135 0zM8.75 24.977c-1.117 0-2.02-.852-2.02-1.909 0-1.056.903-1.909 2.02-1.909s2.02.853 2.02 1.91c0 1.056-.903 1.908-2.02 1.908z",
    fill: "url(#smartphone_svg__paint0_linear_8793_23503)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.135 0H3.365C1.508 0 0 1.425 0 3.182v21.636C0 26.575 1.508 28 3.365 28h10.77c1.857 0 3.365-1.425 3.365-3.182V3.182C17.5 1.425 15.992 0 14.135 0zM8.75 24.977c-1.117 0-2.02-.852-2.02-1.909 0-1.056.903-1.909 2.02-1.909s2.02.853 2.02 1.91c0 1.056-.903 1.908-2.02 1.908z",
    fill: "url(#smartphone_svg__paint1_linear_8793_23503)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "smartphone_svg__paint0_linear_8793_23503",
    x1: 17.849,
    y1: 0.257,
    x2: -7.587,
    y2: 16.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "smartphone_svg__paint1_linear_8793_23503",
    x1: 17.461,
    y1: 0.062,
    x2: -7.596,
    y2: 15.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#688FA5"
  })))));
}

export default __webpack_public_path__ + "./fonts/smartphone.6ec64851b1b1627b785d3f3357b91333.svg";
export { SvgSmartphone as ReactComponent };